import { ICategory } from 'models';
import { filterArrayOfObjectsDuplicates } from 'helpers';

export function mergeCategoryLists(
	prevList?: ICategory[],
	newList?: ICategory[],
) {
	if (prevList && newList) {
		const mergedCategoryList = newList.map((templateCategory) => {
			const partnerCategory = prevList.find(
				({ id }) => id === templateCategory.id,
			);
			if (partnerCategory) {
				return {
					...templateCategory,
					surveyServices: filterArrayOfObjectsDuplicates(
						[
							...(templateCategory.surveyServices || []),
							...(partnerCategory.surveyServices || []),
						],
						'id',
					),
				};
			}
			return templateCategory;
		});

		return filterArrayOfObjectsDuplicates(
			[...mergedCategoryList, ...prevList],
			'id',
		);
	}
}
